export class ViewPortSizeProvider {
    public canvasWidthPx: number;
    public canvasHeightPx: number;

    constructor(canvasWidthPx: number = window.innerWidth, canvasHeightPx: number = window.innerHeight) {
        this.canvasWidthPx = canvasWidthPx;
        this.canvasHeightPx = canvasHeightPx;
    }
}
